import { v4 as newUUID } from "uuid";

export function generateUUID() {
	return newUUID();
}
